import dayjs from "dayjs";
import styles from "../../../styles/beneficios/BenefitMetrics.module.css";
import { Currency } from "../../utils/Currency";

const st = (className) => styles[className];

export const BenefitMetrics = ({ benefit }) => {
  CHART_DATA.labels = getPeriodRange();
  CHART_DATA.datasets[0].data = getUsesByDay(benefit?.reports);

  return (
    <div className={st("benefit-infos")}>
      <div className={st("totalizer")}>
        <div className={st("card")}>
          <p className={st("value")}>
            {Currency.formatCurrency(benefit.sales_total)}
          </p>
          <p>Valor em vendas</p>
        </div>
        <div className={st("card")}>
          <p className={st("value")}>{(benefit.uses || 0.0).toFixed(0)}</p>
          <p>Quantidade de usos</p>
        </div>
        <div className={st("card")}>
          <p className={st("value")}>
            {Currency.formatCurrency(
              (benefit.sales_total || 0) / (benefit.uses || 1)
            )}
          </p>
          <p>Ticket médio</p>
        </div>
      </div>
    </div>
  );
};

const getPeriodRange = () => {
  const currentDate = dayjs();
  let begin = dayjs().subtract(29, "day");
  const period = [];
  while (begin.isSame(currentDate) || begin.isBefore(currentDate)) {
    period.push(begin.format("DD/MM"));
    begin = begin.add(1, "day");
  }
  return period;
};

const getUsesByDay = (reports = []) => {
  const period = getPeriodRange();
  const usesByDay = period.reduce((prev, next) => ({ ...prev, [next]: 0 }), {});

  reports.forEach((report) => {
    const reportDate = dayjs(report.created_at).format("DD/MM");
    if (reportDate in usesByDay) {
      usesByDay[reportDate] = report.uses;
    }
  });

  return Object.entries(usesByDay).map(([_, uses]) => uses);
};

const CHART_DATA = {
  labels: [],
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: "#82D997",
      borderColor: "#82D997",
      borderRadius: 30,
      borderSkipped: false,
      stack: "Stack 0",
    },
  ],
};

const CHART_OPTIONS = {
  cutoutPercentage: 62.5,
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: false,
    fullWidth: false,
  },
  barThickness: 5,
};
